exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add-button[data-v-62965d10]{margin:32px 0 0}.content-table .table-head[data-v-62965d10]{font-weight:700}.content-table .row.content[data-v-62965d10],.content-table .table-head[data-v-62965d10]{border-bottom:1px solid rgba(0,0,38,.1);margin:0;height:48px;line-height:48px}.content-table .row.content[data-v-62965d10]:hover{background:rgba(0,0,38,.05);cursor:pointer}.content-table .row.content>div[data-v-62965d10]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-62965d10","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pages/Backend/Contents/Contents.vue
// module id = 633
// module chunks = 0